// extracted by mini-css-extract-plugin
export default {"education-and-research__container":"style_education-and-research__container__9Fp6H","education-and-research__box":"style_education-and-research__box__V5sFt"};